<script lang="ts" setup>
// 擦除第三方组件类型，避免其内部 element-plus 类型泄漏进 _sfc_main 导致 d.ts 生成报 TS2742
import { ElScrollbar as _ElScrollbar } from "element-plus";
// @ts-nocheck
import { nextTick, ref } from "vue";
const emit = defineEmits(["changeFloor"]);

const ElScrollbar: any = _ElScrollbar;

// 楼层
const floorData = ref<any[]>([]);
const scrollbar = ref<any>(null);
const list = ref<any>(null);
const itemRefs = ref<any[]>([]);

// 设置列表项引用
const setItemRef = (el: any) => {
  if (el) {
    itemRefs.value.push(el);
  }
};

function clickFloor(index: number, item: any) {
  floorData.value.map((ser) => (ser.type = false));
  floorData.value[index].type = true;
  emit("changeFloor", item);
  // eslint-disable-next-line no-use-before-define
  scrollToIndex(index);
}

// 滚动到指定索引
const scrollToIndex = (index: number) => {
  nextTick(() => {
    if (itemRefs.value[index] && scrollbar.value) {
      const scrollContainer = scrollbar.value.$el.querySelector(
        ".el-scrollbar__wrap",
      );
      const containerHeight = scrollContainer.clientHeight;
      const itemOffsetTop = itemRefs.value[index].offsetTop;
      const itemHeight = itemRefs.value[index].clientHeight;

      scrollbar.value.setScrollTop(
        itemOffsetTop - containerHeight / 2 + itemHeight / 2,
      );
    }
  });
};

const init = (listFloor: any[], defaultFloor: any) => {
  const arr = listFloor.sort((a, b) => b.floor - a.floor);

  floorData.value = arr.map((item) => {
    const name =
      item.floor === 0
        ? "室外"
        : item.floor > 0
          ? `${item.floor}F`
          : `${Math.abs(item.floor)}B`;

    if (item.floor === defaultFloor.floor) {
      item.type = true;
    }

    return {
      ...item,
      floorName: item.floorName || name,
    };
  });

  // 初始化后滚动到激活的楼层
  nextTick(() => {
    const activeIndex = floorData.value.findIndex((item) => item.type);
    // alert(activeIndex)
    if (activeIndex !== -1) {
      scrollToIndex(activeIndex);
    }
  });
};

defineExpose({
  init,
  scrollToIndex, // 暴露方法以便外部调用
});
</script>

<template>
  <div class="flex items-center justify-center overflow-hidden t-floor">
    <ElScrollbar ref="scrollbar" class="flex items-center justify-center">
      <ul ref="list">
        <li
          v-for="(item, index) in floorData"
          :key="index"
          :ref="setItemRef"
          :class="[item.type ? (index % 2 ? 'activeted1' : 'activeted2') : '']"
          @click="clickFloor(index, item)"
        >
          {{ item.floorName }}
        </li>
      </ul>
    </ElScrollbar>
  </div>
</template>
